import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { AbstractControl, FormBuilder, ValidationErrors, Validators } from '@angular/forms';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { Config } from 'src/app/app-constant';
import { HttpService } from 'src/app/service/http/http.service';
import { countryList, formatDateToLocalIso, strictEmailValidator } from 'src/app/shared/commen-function-file';
import { ConfirmationPopupComponent } from 'src/app/shared/popups/confirmation-popup/confirmation-popup.component';
export const MY_DATE_FORMATS = {
  parse: {
    dateInput: 'DD/MM/YYYY',
  },
  display: {
    dateInput: 'DD/MM/YYYY',
    monthYearLabel: 'MMMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
}
@Component({
  selector: 'app-elcm-condidate-from',
  templateUrl: './elcm-condidate-from.component.html',
  styleUrls: ['./elcm-condidate-from.component.scss'],
  providers: [
    { provide: MAT_DATE_LOCALE, useValue: 'en-GB' }, // Use en-GB to get DD/MM/YYYY format
    { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE] },
    { provide: MAT_DATE_FORMATS, useValue: MY_DATE_FORMATS },
  ],
})
export class ElcmCondidateFromComponent implements OnInit {
  userName: any | null;
  loggedInUserRole: any | null;
  companyLogo: any | null;
  employeeForm: any;
  buttonColorName: any;
  getCountryList: any = []
  candidateId: any;
  companyId: any;
  currentDate: any
  addSubmitForm: boolean = false;
  year: any;
  fiscalYear: any;
  constructor(public dialog: MatDialog, public router: Router, private fb: FormBuilder, private http: HttpClient, private route: ActivatedRoute, private httpservice: HttpService, private config: Config,) {
    this.currentDate = (new Date()).toISOString();
    this.employeeForm = this.fb.group({
      // General Information
      salutation: ['', Validators.required],
      firstName: ['', Validators.required],
      lastName: ['', Validators.required],
      gender: ['', Validators.required],
      country: ['India', Validators.required],
      presentAddress: ['', [Validators.required, Validators.maxLength(255)]],
      permanentAddress: ['', [Validators.maxLength(255)]],
      maritalStatus: ['',],
      dateOfBirth: ['', Validators.required],
      age: [''],
      personalEmail: ['', [Validators.required, Validators.email, strictEmailValidator]],
      aadhaarCardNo: ['', [Validators.required, Validators.pattern('^[0-9]{12}$')]],
      panNo: ['', [Validators.required, Validators.pattern('^[A-Z]{5}[0-9]{4}[A-Z]$')]],
      unaNo: ['', Validators.pattern(/^\d{12}$/)],
      mobileNo: ['', [
        Validators.required,
        Validators.pattern(/^[0-9]{10}$/)
      ]],

      previousExperience: ['', [Validators.pattern(/^\d{1,2}(\.\d{1,2})?$/)]],
      emergencyContact: ['', [Validators.pattern('^[0-9]{10}$')]],
      bloodGroup: [''],
      fathersName: ['', [Validators.maxLength(255), Validators.pattern(/^[[a-zA-Z\s'.-]+$/)]],
      mothersName: ['', [Validators.maxLength(255), Validators.pattern(/^[[a-zA-Z\s'.-]+$/)]],
      spouseName: ['', [Validators.maxLength(255), Validators.pattern(/^[[a-zA-Z\s'.-]+$/)]],
      noOfChildren: ['', [Validators.pattern(/^[0-9]+$/), Validators.max(20)]], // Assuming a max of 20
      relativeWorking: ['No'],

      // Education Related Information
      highestEducation: ['', [Validators.maxLength(255),
      Validators.pattern(/^[[a-zA-Z0-9\s.'.,_\-]+$/)]],
      highestEducationInstitute: ['', [Validators.maxLength(255),
      Validators.pattern(/^[[a-zA-Z0-9\s.'.,_\-]+$/)]],
      highestEducationYear: ['', [Validators.pattern('^[0-9]{4}$'), this.disallowInvalidYearValidator]],
      highestEducationMarks: ['', [Validators.pattern(/^\d{1,3}(\.\d{1,2})?$/), // e.g., 95, 95.5, 99.99
      Validators.max(100)]],
      secondEducation: [
        '',
        [
          Validators.maxLength(255),
          Validators.pattern(/^[a-zA-Z0-9\s.,'_\-]*$/)

        ]
      ],
      secondEducationInstitute: [
        '',
        [
          Validators.maxLength(255),
          Validators.pattern(/^[a-zA-Z0-9\s.,'_\-]*$/)

        ]
      ],
      secondEducationYear: ['', [Validators.pattern('^[0-9]{4}$'), this.disallowInvalidYearValidator]],
      secondEducationMarks: ['', [
        Validators.pattern(/^\d{1,3}(\.\d{1,2})?$/), // allows up to 2 decimal places
        Validators.max(100)
      ]],
      thirdEducation: [
        '',
        [
          Validators.maxLength(255),
          Validators.pattern(/^[a-zA-Z0-9\s.,'_\-]*$/)

        ]
      ],
      thirdEducationInstitute: [
        '',
        [
          Validators.maxLength(255),
          Validators.pattern(/^[a-zA-Z0-9\s.,'_\-]*$/)

        ]
      ],
      thirdEducationYear: ['', [Validators.pattern('^[0-9]{4}$'), this.disallowInvalidYearValidator]],
      thirdEducationMarks: ['', [
        Validators.pattern(/^\d{1,3}(\.\d{1,2})?$/),  // Validates up to 3 digits + optional 2 decimal places
        Validators.max(100)
      ]],
      highestProfessional: ['', [
        Validators.maxLength(255),
        Validators.pattern(/^[a-zA-Z0-9\s .,'-]*$/)

      ]],
      highestProfessionalInstitute: ['', [
        Validators.maxLength(255),
        Validators.pattern(/^[a-zA-Z0-9\s .,'-]*$/)

      ]],

      highestProfessionalYear: ['', [Validators.pattern('^[0-9]{4}$'), this.disallowInvalidYearValidator]],
      highestProfessionalMarks: [
        '',
        [
          Validators.pattern(/^\d{1,3}(\.\d{1,2})?$/), // Valid decimal up to 2 digits
          Validators.max(100)                         // Max value: 100
        ]
      ],


      // Prior Employment Related Information
      lastOrganisation: [
        '',
        [
          Validators.maxLength(255),
          Validators.pattern(/^[a-zA-Z0-9\s.,'_\-]*$/)
        ]
      ],

      lastOrganisationJoiningDate: [''],
      lastOrganisationLastWorkingDate: [''],
      lastOrganisationDepartment: ['', [
        Validators.maxLength(255),
        Validators.pattern(/^[a-zA-Z0-9\s.,'_\-]*$/)
      ]],
      lastOrganisationDesignation: ['', [
        Validators.maxLength(255),
        Validators.pattern(/^[a-zA-Z0-9\s.,'_\-]*$/)
      ]],
      lastToLastOrganisation: ['', [
        Validators.maxLength(255),
        Validators.pattern(/^[a-zA-Z0-9\s.,'_\-]*$/)
      ]],
      lastToLastOrganisationJoiningDate: [''],
      lastToLastOrganisationLastWorkingDate: [''],
      lastToLastOrganisationDepartment: ['', [
        Validators.maxLength(255),
        Validators.pattern(/^[a-zA-Z0-9\s.,'_\-]*$/)
      ]],
      lastToLastOrganisationDesignation: ['', [
        Validators.maxLength(255),
        Validators.pattern(/^[a-zA-Z0-9\s.,'_\-]*$/)
      ]],
      anyOtherOrganisation: ['', [
        Validators.maxLength(255),
        Validators.pattern(/^[a-zA-Z0-9\s.,'_\-]*$/)
      ]],
      anyOtherOrganisationJoiningDate: [''],
      anyOtherOrganisationLastWorkingDate: [''],
      anyOtherOrganisationDepartment: ['', [
        Validators.maxLength(255),
        Validators.pattern(/^[a-zA-Z0-9\s.,'_\-]*$/)
      ]],
      anyOtherOrganisationDesignation: ['', [
        Validators.maxLength(255),
        Validators.pattern(/^[a-zA-Z0-9\s.,'_\-]*$/)
      ]]
    });
  }
  disallowInvalidYearValidator(control: AbstractControl): ValidationErrors | null {
    const value = control.value;

    // Skip validation if empty (since it's not mandatory)
    if (!value) {
      return null;
    }

    // Must be exactly 4 digits
    if (!/^\d{4}$/.test(value)) {
      return { pattern: true };
    }

    // Disallow years starting with 00 (e.g., 0000–0099)
    if (/^00/.test(value)) {
      return { invalidYear: true };
    }

    return null;
  }

  ngOnInit() {
    this.route.queryParams.subscribe(params => {
      this.candidateId = params['candidateId'];
      this.companyId = params['companyId'];

      console.log('Candidate ID:', this.candidateId);
      console.log('Company ID:', this.companyId);
    });
    this.userName = sessionStorage.getItem('loggedInUserName');
    this.buttonColorName = sessionStorage.getItem('buttonColorName');
    this.loggedInUserRole = sessionStorage.getItem('loggedInUserRole');

    console.log(this.companyLogo);

    this.getAllCountryList();
    this.getData();
    this.getLogoData();
  }
  allowOnlyDigits(event: KeyboardEvent) {
    const charCode = event.key.charCodeAt(0);
    if (charCode < 48 || charCode > 57) {
      event.preventDefault();
    }
  }
  preventFloatInput(event: KeyboardEvent): void {
    const invalidKeys = ['.', 'e', '+', '-'];
    if (invalidKeys.includes(event.key)) {
      event.preventDefault();
    }
  }

  preventInvalidPaste(event: ClipboardEvent): void {
    const clipboardData = event.clipboardData?.getData('text');
    if (clipboardData && !/^\d+$/.test(clipboardData)) {
      event.preventDefault();
    }
  }
  getData() {
    this.http.get(`${this.config.candidateGetData}?candidateId=${this.candidateId}&companyId=${this.companyId}`).subscribe((response: any) => {
      console.log(response.data.firstName);
      this.fiscalYear = response?.data?.fiscalYear,
        this.year = response?.data?.year;
      this.employeeForm.patchValue({
        salutation: response.data.salutation,
        firstName: response.data.firstName,
        lastName: response.data.lastName,
        personalEmail: response.data.candidateEmail,
        country: 'India'
      });

    })
  }



  imgurl: any;
  getLogoData() {
    this.http.get(`${this.config.logoGetData}?companyId=${this.companyId}`).subscribe((response: any) => {
      // turl=his.imgresponse.data?.logoUrl;
      this.imgurl = response.data?.logoUrl;

      // Decode multiple times to get the actual image URL
      // Try decoding up to 5 times
      // this.imgurl = decodeURIComponent(decodeURIComponent(rawUrl));




    })
  }
  bloodGroups: string[] = [
    'A+',
    'A-',
    'B+',
    'B-',
    'AB+',
    'AB-',
    'O+',
    'O-'
  ];
  closeDialog() {

  }
  handleInput(event: any, fieldType: string) {
    const inputElement = event.target as HTMLInputElement;

    if (fieldType === 'mobile' || fieldType === 'emergencyContact') {
      // Allow only numbers and restrict length to 10
      const pattern = /^[0-9]$/;
      const inputChar = event.key;

      if (!pattern.test(inputChar) || inputElement.value.length >= 10) {
        event.preventDefault();
      }
    } else if (fieldType === 'pan') {
      // Convert PAN to uppercase
      inputElement.value = inputElement.value.toUpperCase();
      this.employeeForm.controls['panNo'].setValue(inputElement.value);
    } else if (fieldType === 'aadhaar') {
      // Aadhaar validation
      const pattern = /^[0-9]$/;
      const inputChar = event.key;

      if (!pattern.test(inputChar) || inputElement.value.length >= 12) {
        event.preventDefault();
      }
    }

  }
  restrictCharacters(event: KeyboardEvent, fieldType: string): void {
    const inputChar = event.key;
    const inputElement = event.target as HTMLInputElement;

    const allowedControlKeys = [
      'Backspace', 'ArrowLeft', 'ArrowRight', 'Tab', 'Delete'
    ];

    const isNumber = /^[0-9]$/.test(inputChar);
    const isControlKey = allowedControlKeys.includes(inputChar);

    if (fieldType === 'unaNo') {
      const currentLength = inputElement.value.length;

      // If it's not a digit or allowed control key, block it
      if ((!isNumber && !isControlKey) || (isNumber && currentLength >= 12)) {
        event.preventDefault();
      }
    }
  }

  preventNegativeValues(event: KeyboardEvent) {
    if (event.key === '-' || event.key === 'e' || event.key === 'E') {
      event.preventDefault(); // Stops "-" and "e/E" from being typed
    }
  }


  hasError(controlName: string, errorType: string) {
    const control = this.employeeForm.get(controlName);
    return control?.hasError(errorType) && control.touched;
  }

  countryList: any = countryList
  getAllCountryList() {
    // this.http.get("https://restcountries.com/v3.1/all").subscribe((data: any) => {
    //   this.getCountryList = [];
    //   if(data){
    //     var getCountryList = data.map((country: { name: { common: any; }; }) => country.name.common);
    //     getCountryList?.forEach((ele: any) => {
    //       let obj = {
    //         id: ele,h
    //         name: ele,
    //       }
    //       this.getCountryList.push(obj);
    //     });
    //   }else{


    // })

    var getCountryList = this.countryList.map((country: any) => country.country);
    getCountryList?.forEach((ele: any) => {
      let obj = {
        id: ele,
        name: ele,
      }
      this.getCountryList.push(obj);
    });


    this.getCountryList = this.getCountryList.sort((a: { name: any; }, b: { name: any; }) => a.name.localeCompare(b.name));
    console.log(this.getCountryList);
  }

  calculateAgeFromDOB() {
    const dob = new Date(this.employeeForm.value.dateOfBirth)
    const today = new Date();
    let age = today.getFullYear() - dob.getFullYear();
    const monthDiff = today.getMonth() - dob.getMonth();

    // Adjust age if the current date is before the birth date in the current year
    if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < dob.getDate())) {
      age--;
    }

    this.employeeForm.controls['age'].setValue(age);
  }

  getFiscalYearDynamic(): { fiscalYearFormat: string; year: string } {
    const now = new Date();
    const year = now.getFullYear();
    const month = now.getMonth() + 1; // JavaScript months are 0-indexed

    // Determine fiscal year type dynamically (fetch from API, DB, or config)
    const startMonth = this.getConfiguredFiscalYearStartMonth(); // Dynamically fetch this value

    let fiscalYearFormat = "";
    let fiscalYear = "";

    if (startMonth === 1) {
      fiscalYearFormat = "Jan_Dec";
      fiscalYear = `${year}-${year + 1}`;
    } else if (startMonth === 4) {
      fiscalYearFormat = "Apr_Mar";
      fiscalYear = month >= 4 ? `${year}-${year + 1}` : `${year - 1}-${year}`;
    } else {
      throw new Error("Unsupported fiscal year start month. Use 1 for Jan-Dec or 4 for Apr-Mar.");
    }

    return { fiscalYearFormat, year: fiscalYear };
  }

  // **Mock function to fetch fiscal start month dynamically (Replace with API call or config)**
  getConfiguredFiscalYearStartMonth(): number {
    // Example: Fetch from an API or config file
    return 4; // Change dynamically based on your business logic
  }

  // **Usage**


isLoading: boolean = false;

saveEmployeeeData() {
  console.log('Employee Form:', this.employeeForm);

  const fiscalYearData = this.getFiscalYearDynamic();
  console.log('Fiscal Year Data:', fiscalYearData);

  const employeeFromData = this.employeeForm.value;

  // ✅ Start loader before any async work
  this.isLoading = true;

  // ✅ Stop early if form invalid
  if (this.employeeForm.invalid) {
    this.addSubmitForm = true;
    this.employeeForm.markAllAsTouched();
    this.isLoading = false; // stop loader since not proceeding
    return;
  }

  const formData = {
    fiscalYear: this.fiscalYear,
    year: this.year,
    companyId: parseInt(this.companyId),
    candidateId: parseInt(this.candidateId),

    gender: employeeFromData.gender,
    address: employeeFromData.presentAddress,
    permanentAddress: employeeFromData.permanentAddress,
    country: employeeFromData.country,
    maritalStatus: employeeFromData?.maritalStatus || null,
    dateOfBirth: employeeFromData?.dateOfBirth
      ? formatDateToLocalIso(new Date(employeeFromData?.dateOfBirth))
      : '',
    age: employeeFromData.age,
    aadharNo: employeeFromData.aadhaarCardNo,
    panNo: employeeFromData.panNo,
    uan: employeeFromData.unaNo,
    contactNo: employeeFromData.mobileNo,
    totalExperience: employeeFromData.previousExperience,
    emergencyContactNo: employeeFromData.emergencyContact,
    bloodGroup: employeeFromData.bloodGroup,
    fathersName: employeeFromData.fathersName,
    mothersName: employeeFromData.mothersName,
    spouseName: employeeFromData.spouseName,
    noOfChildren: employeeFromData.noOfChildren,
    isRelativeWorking: employeeFromData?.relativeWorking === 'Yes',

    // Education 1
    highestEducationQualification: employeeFromData.highestEducation,
    highestEducationInstitute: employeeFromData.highestEducationInstitute,
    highestEducationYearOfPassing: employeeFromData.highestEducationYearOfPassing,
    highestEducationMarks: employeeFromData.highestEducationMarks,

    // Education 2
    highestEducationQualification2: employeeFromData.secondEducation,
    highestEducationInstitute2: employeeFromData.secondEducationInstitute,
    highestEducationYearOfPassing2: employeeFromData.secondEducationYear,
    highestEducationMarks2: employeeFromData.secondEducationMarks,

    // Education 3
    highestEducationQualification3: employeeFromData.thirdEducation,
    highestEducationInstitute3: employeeFromData.thirdEducationInstitute,
    highestEducationYearOfPassing3: employeeFromData.thirdEducationYear,
    highestEducationMarks3: employeeFromData.thirdEducationMarks,

    // Professional
    highestProfessionalQualification: employeeFromData.highestProfessional,
    highestProfessionalInstitute: employeeFromData.highestProfessionalInstitute,
    highestProfessionalYearOfPassing: employeeFromData.highestProfessionalYearOfPassing,
    highestProfessionalMarks: employeeFromData.highestProfessionalMarks,

    // Prior Employment 1
    lastOrganisationName: employeeFromData.lastOrganisation,
    lastOrganisationDoj: employeeFromData?.lastOrganisationJoiningDate
      ? formatDateToLocalIso(new Date(employeeFromData?.lastOrganisationJoiningDate))
      : '',
    lastOrganisationLwd: employeeFromData?.lastOrganisationLastWorkingDate
      ? formatDateToLocalIso(new Date(employeeFromData?.lastOrganisationLastWorkingDate))
      : '',
    lastOrganisationDepartment: employeeFromData.lastOrganisationDepartment,
    lastOrganisationDesignation: employeeFromData.lastOrganisationDesignation,

    // Prior Employment 2
    lastToLastOrganisationName: employeeFromData.lastToLastOrganisation,
    lastToLastOrganisationDoj: employeeFromData?.lastToLastOrganisationJoiningDate
      ? formatDateToLocalIso(new Date(employeeFromData?.lastToLastOrganisationJoiningDate))
      : '',
    lastToLastOrganisationLwd: employeeFromData?.lastToLastOrganisationLastWorkingDate
      ? formatDateToLocalIso(new Date(employeeFromData?.lastToLastOrganisationLastWorkingDate))
      : '',
    lastToLastOrganisationDepartment: employeeFromData.lastToLastOrganisationDepartment,
    lastToLastOrganisationDesignation: employeeFromData.lastToLastOrganisationDesignation,

    // Other Employment
    otherOrganisationName: employeeFromData.anyOtherOrganisation,
    otherOrganisationDoj: employeeFromData?.anyOtherOrganisationJoiningDate
      ? formatDateToLocalIso(new Date(employeeFromData?.anyOtherOrganisationJoiningDate))
      : '',
    otherOrganisationLwd: employeeFromData?.anyOtherOrganisationLastWorkingDate
      ? formatDateToLocalIso(new Date(employeeFromData?.anyOtherOrganisationLastWorkingDate))
      : '',
    otherOrganisationDepartment: employeeFromData.anyOtherOrganisationDepartment,
    otherOrganisationDesignation: employeeFromData.otherOrganisationDesignation,

    mailSubject: 'reply',
    mailBody: ' '
  };

  console.log('Payload to send:', formData);

  // ✅ Call API
  this.httpservice.callPostServiceForLogin(this.config.candidateCreateform, formData)
    .subscribe({
      next: (data: any) => {
        console.log('API Success:', data);
        this.isLoading = false;

        if (data) {
          this.router.navigate(['welcome']);
        }
      },
      error: (error: any) => {
        console.error('API Error:', error);
        this.isLoading = false;

        this.dialog.open(ConfirmationPopupComponent, {
          disableClose: true,
          height: '25%',
          width: '30%',
          data: {
            msg: error?.error?.message || error?.error?.details || 'Something went wrong!',
            btn2: 'OK',
            btn2BgColor: 'red',
            showSuccessIcon: false,
            showSuccessMessage: false,
            showCloseIcon: false
          }
        });
      }
    });
}

}


